<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Remote User Location</p-heading>

  <p-button
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
    (click)="showCreateModal = true"
  >
    Add New Remote User Location
  </p-button>
</div>

<p-divider aria-hidden="true" />

<section class="list">
  <p-heading *ngrxLet="data$ | async as remoteUserLocations" [size]="'small'" [tag]="'h4'">
    {{ remoteUserLocations?.length }} Remote User Locations
  </p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    <div *ngIf="dataError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadData()"
      >
        Reload Remote User Locations
      </p-button-pure>
    </div>

    <ng-container *ngIf="!dataError && data">
      <div class="overlay-spinner-host">
        <ng-container *ngIf="loading$ | async" [ngTemplateOutlet]="overlaySpinner" />

        <p-table caption="Remote User Locations list table">
          <p-table-head>
            <p-table-head-row>
              <p-table-head-cell style="width: 1%">Edit</p-table-head-cell>
              <p-table-head-cell style="width: 98%">Name</p-table-head-cell>
              <p-table-head-cell style="width: 1%">Delete</p-table-head-cell>
            </p-table-head-row>
          </p-table-head>

          <p-table-body>
            <p-table-row *ngFor="let remoteUserLocation of data; trackBy: trackRemoteUserLocation">
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/edit.svg'"
                  [hideLabel]="true"
                  (click)="openEditModal(remoteUserLocation)"
                >
                  Edit {{ remoteUserLocation.description }}
                </p-button-pure>
              </p-table-cell>

              <p-table-cell>
                {{ remoteUserLocation.description }}
              </p-table-cell>
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/delete.svg'"
                  [hideLabel]="true"
                  (click)="openDeleteModal(remoteUserLocation)"
                >
                  Delete {{ remoteUserLocation.description }}
                </p-button-pure>
              </p-table-cell>
            </p-table-row>
          </p-table-body>
        </p-table>
      </div>
    </ng-container>
  </ng-container>
</section>

<opa-remote-user-location-create
  [open]="showCreateModal"
  (dismiss)="showCreateModal = false; $event && reloadData()"
/>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>

<ng-template #overlaySpinner>
  <div class="overlay-spinner"><p-spinner /></div>
</ng-template>

<opa-remote-user-location-delete
  [open]="showDeleteModal"
  [remoteUserLocation]="(remoteUserLocation$ | async) ?? undefined"
  (dismiss)="closeDeleteModal($event)"
/>

<opa-remote-user-location-edit
  [open]="showEditModal"
  [remoteUserLocation]="(remoteUserLocation$ | async) ?? undefined"
  (dismiss)="closeEditModal($event)"
/>
